import React, { PureComponent, ReactNode } from 'react'
import { DispatchProp } from 'react-redux'
import { AnyAction } from 'redux'
import { Button, Modal, Spinner } from '../../../components'
import { connectRedux } from '../../../helpers/connectRedux'
import { IBookingScheduler } from '../../../models'
import { LiteralsService } from '../../../services'
import { removeBookingSchedulerAction, setSelectedBookingSchedulerModalAction } from '../../../store/actions'
import { IStoreState } from '../../../store/states'

interface IProps extends DispatchProp<AnyAction> {
  isLoading: boolean
  selected: IBookingScheduler | null
}

class RemoveBookingSchedulerModal extends PureComponent<IProps> {
  public render(): ReactNode {
    const { selected } = this.props

    if (!selected) return null

    return (
      <Modal className="small" isHidden={ false } onOverlayClick={ this.handleClose }>
        { this.modalContent }
      </Modal>
    )
  }

  private get modalContent(): ReactNode {
    const { isLoading, selected } = this.props

    if (isLoading) {
      return (
        <article className="spinner-container">
          <Spinner />
        </article>
      )
    }

    return (
      <>
        <header>
          <h3>{ LiteralsService.get('removeBookingScheduler', true) }:</h3>
        </header>
        <section className="content">
          <p>{ selected && selected.name }</p>
        </section>
        <footer>
          <Button
            onPress={ this.handleRemove }
            title={ LiteralsService.get('delete', true) }
            styles={{ width: '150px' }}
            filled
          />
          <Button
            onPress={ this.handleClose }
            title={ LiteralsService.get('cancel', true) }
            styles={{ width: '150px' }}
          />
        </footer>
      </>
    )
  }

  private handleRemove = (): void => {
    this.props.dispatch(removeBookingSchedulerAction())
  }

  private handleClose = (): void => {
    this.props.dispatch(setSelectedBookingSchedulerModalAction(null))
  }
}

const mapStateToProps = ({ bookingScheduler }: IStoreState) => ({
  isLoading: bookingScheduler.isLoadingBookingScheduler,
  selected: bookingScheduler.selectedBookingScheduler
})

export default connectRedux(mapStateToProps, RemoveBookingSchedulerModal)
